export default __webpack_public_path__ + "static/media/0.7d5443ee.svg";